"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  value: _propTypes.default.string.isRequired,
  handleItemRemove: _propTypes.default.func.isRequired,
  deleteButton: _propTypes.default.node.isRequired
};

var MultipleValueTextInputItem = function MultipleValueTextInputItem(props) {
  var value = props.value,
      handleItemRemove = props.handleItemRemove,
      deleteButton = props.deleteButton;
  return /*#__PURE__*/_react.default.createElement("span", {
    className: "multiple-value-text-input-item",
    role: "listitem"
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "multiple-value-text-input-item-value",
    "data-testid": "value"
  }, value), ' ', /*#__PURE__*/_react.default.createElement("span", {
    className: "multiple-value-text-input-item-delete-button",
    "data-value": value,
    tabIndex: "-1",
    role: "button",
    onKeyPress: function onKeyPress() {
      return handleItemRemove(value);
    },
    onClick: function onClick() {
      return handleItemRemove(value);
    }
  }, deleteButton));
};

MultipleValueTextInputItem.propTypes = propTypes;
var _default = MultipleValueTextInputItem;
exports.default = _default;